export default function (editor, opts = {}) {
  const domc = editor.DomComponents;
  const defaultType = domc.getType('default');
  const defaultModel = defaultType.model;
  const defaultView = defaultType.view;
  const pfx = opts.pfx;
  const eventTypes = ['onclick', 'onmouseenter'];
  const { toolbarBtnDrapCodeIconsSectionCode, refs, commands, events, label } = opts;

  let timedInterval;
  domc.addType('script', {
    view: {
      onRender() {
        const isCC = this.model.closestType(refs.drapcodeIconsRef);
        isCC && (this.el.innerHTML = '');
      },
    },
  });

  domc.addType(refs.drapcodeIconsRef, {
    model: defaultModel.extend(
      {
        defaults: {
          ...defaultModel.prototype.defaults,
          name: 'Icon',
          editable: true,
          droppable: false,
          projectId: opts.projectId,
          ...opts.propsDrapCodeIconsSectionCode,
          // 'custom-name': 'Drapcode Icon',
          width: 24,
          height: 24,
          fill: 'none',
          stroke: 'currentColor',
          'stroke-width': 2,
          'stroke-linecap': 'round',
          'stroke-linejoin': 'round',
          traits: [
            {
              name: 'width',
              type: 'number',
              placeholder: '0-100',
              step: 1,
              label: 'Width',
              value: 24,
              changeProp: 1,
            },
            {
              name: 'height',
              type: 'number',
              placeholder: '0-100',
              step: 1,
              label: 'Height',
              value: 24,
              changeProp: 1,
            },
            {
              name: 'fill',
              type: 'color',
              placeholder: 'none',
              label: 'Fill',
              value: 'none',
              changeProp: 1,
            },
            {
              name: 'stroke',
              type: 'color',
              placeholder: 'stroke',
              label: 'Stroke',
              value: 'currentColor',
              changeProp: 1,
            },
            {
              name: 'stroke-width',
              type: 'number',
              placeholder: '0-100',
              step: 1,
              label: 'Stroke Width',
              value: 2,
              changeProp: 1,
            },
            {
              type: 'select',
              label: 'Stroke Linecap',
              name: 'stroke-linecap',
              options: [
                { id: 'butt', name: 'Butt' },
                { id: 'round', name: 'Round' },
                { id: 'square', name: 'Square' },
              ],
              value: 'round',
              changeProp: 1,
            },
            {
              type: 'select',
              label: 'Stroke Linejoin',
              name: 'stroke-linejoin',
              options: [
                { id: 'crop', name: 'Crop' },
                { id: 'miter', name: 'Miter' },
                { id: 'arcs', name: 'Arcs' },
                { id: 'bevel', name: 'Bevel' },
                { id: 'round', name: 'Round' },
                { id: 'fallback', name: 'Fallback' },
              ],
              value: 'round',
              changeProp: 1,
            },
            {
              type: 'select',
              label: 'Event Type',
              name: 'eventType',
              options: [
                { id: 'onclick', name: 'On Click' },
                { id: 'onmouseenter', name: 'On Hover' },
              ],
              value: 'onclick',
              changeProp: 1,
            },
            {
              type: 'select',
              label: 'Event',
              name: 'event',
              options: [],
              value: '',
              changeProp: 1,
            },
          ].concat(defaultModel.prototype.defaults.traits),
        },

        init() {
          this.listenTo(
            this,
            `change:${refs.keyDrapCodeIconsCustomCode}`,
            this.onDrapCodeIconsSectionCodeChange,
          );
          const eventOptions = events.map((event) => ({
            value: event.eventName,
            name: event.eventTitle,
          }));
          this.getTrait('event').set('options', eventOptions);

          this.listenTo(this, 'change:width', this.updateWidth);
          this.listenTo(this, 'change:height', this.updateHeight);
          this.listenTo(this, 'change:fill', this.updateFill);
          this.listenTo(this, 'change:stroke', this.updateStroke);
          this.listenTo(this, 'change:stroke-width', this.updateStrokeWidth);
          this.listenTo(this, 'change:stroke-linecap', this.updateStrokeLinecap);
          this.listenTo(this, 'change:stroke-linejoin', this.updateStrokeLinejoin);
          this.listenTo(this, 'change:event', this.updateEvent);
          this.listenTo(this, 'change:eventType', this.updateEventType);

          const initialCode = this.get(refs.keyDrapCodeIconsCustomCode) || opts.placeholderContent;

          !this.components().length && this.components(initialCode);
          const toolbar = this.get('toolbar');
          const id = 'drapcode-icons';

          // Add the custom code toolbar button if requested and it's not already in
          if (
            toolbarBtnDrapCodeIconsSectionCode &&
            !toolbar.filter((tlb) => tlb.id === id).length
          ) {
            toolbar.unshift({
              id,
              command: commands.drapcode_icons_custom_code,
              attributes: { class: 'fa fa-star', title: 'Select Icon' },
              ...toolbarBtnDrapCodeIconsSectionCode,
            });
          }
        },

        onDrapCodeIconsSectionCodeChange() {
          this.components(this.get(refs.keyDrapCodeIconsCustomCode));
        },
        updateWidth() {
          const component = editor.getSelected();
          let iconElement = component.findType('svg').length ? component.findType('svg')[0] : null;
          if (iconElement && this.changed['width']) {
            iconElement.addAttributes({ width: this.changed['width'] });
          }
        },
        updateHeight() {
          const component = editor.getSelected();
          let iconElement = component.findType('svg').length ? component.findType('svg')[0] : null;
          if (iconElement && this.changed['height']) {
            iconElement.addAttributes({ height: this.changed['height'] });
          }
        },
        updateFill() {
          const component = editor.getSelected();
          let iconElement = component.findType('svg').length ? component.findType('svg')[0] : null;
          if (iconElement && this.changed['fill']) {
            iconElement.addAttributes({ fill: this.changed['fill'] });
          }
        },
        updateStroke() {
          const component = editor.getSelected();
          let iconElement = component.findType('svg').length ? component.findType('svg')[0] : null;
          if (iconElement && this.changed['stroke']) {
            iconElement.addAttributes({ stroke: this.changed['stroke'] });
          }
        },
        updateStrokeWidth() {
          const component = editor.getSelected();
          let iconElement = component.findType('svg').length ? component.findType('svg')[0] : null;
          if (iconElement && this.changed['stroke-width']) {
            iconElement.addAttributes({ 'stroke-width': this.changed['stroke-width'] });
          }
        },
        updateStrokeLinecap() {
          const component = editor.getSelected();
          let iconElement = component.findType('svg').length ? component.findType('svg')[0] : null;
          if (iconElement && this.changed['stroke-linecap']) {
            iconElement.addAttributes({ 'stroke-linecap': this.changed['stroke-linecap'] });
          }
        },
        updateStrokeLinejoin() {
          const component = editor.getSelected();
          let iconElement = component.findType('svg').length ? component.findType('svg')[0] : null;
          if (iconElement && this.changed['stroke-linejoin']) {
            iconElement.addAttributes({ 'stroke-linejoin': this.changed['stroke-linejoin'] });
          }
        },
        updateEventType() {
          const eventType = this.get('eventType');
          const attrs = this.getAttributes();
          let event = '';
          eventTypes.forEach((eventType) => {
            if (attrs[eventType]) {
              event = attrs[eventType];
              delete attrs[eventType];
            }
          });
          attrs[eventType] = event;
          this.setAttributes(attrs);
        },
        updateEvent() {
          let eventType = this.get('eventType');
          const event = this.get('event');
          const attrs = this.getAttributes();
          eventTypes.forEach((eventType) => {
            if (attrs[eventType]) delete attrs[eventType];
          });
          eventType = eventType ? eventType : 'onclick';
          attrs[eventType] = 'return ' + event + '(event)';
          this.setAttributes(attrs);
        },
      },
      {
        isComponent(el) {
          if (el.getAttribute && el.getAttribute('data-gjs-type') === refs.drapcodeIconsRef) {
            return {
              type: refs.drapcodeIconsRef,
            };
          }
        },
      },
    ),

    view: defaultView.extend({
      // Active on Double Click
      events: {
        dblclick: 'onActive',
      },

      init() {
        this.listenTo(this.model.components(), 'add remove reset', this.onComponentsChange);
        this.onComponentsChange();
      },

      onComponentsChange() {
        timedInterval && clearInterval(timedInterval);
        timedInterval = setTimeout(() => {
          const { model } = this;
          const content = model.get(refs.keyDrapCodeIconsCustomCode) || '';
          let droppable = 1;

          if (content.indexOf('<script') >= 0) {
            this.el.innerHTML = opts.placeholderScript;
            droppable = 0;
          }

          model.set({ droppable });
        }, 0);
      },

      onActive() {
        const target = this.model;
        this.em.get('Commands').run(commands.drapcode_icons_custom_code, { target });
      },
    }),
  });
}
